import {Activity} from '../../../core/activity/activity';
import {WeblinkFaultData} from './weblink-fault-data';
import {WeblinkAttachment} from '../weblink-attachment/weblink-attachment';

export class WeblinkFault {
  IsEditable: boolean;
  IsClosed: boolean;
  Id?: number;
  Data: WeblinkFaultData[] = [];
  Activities?: Activity[];
  Files?: WeblinkAttachment[];
}
